import { render, staticRenderFns } from "./waiting-approval.vue?vue&type=template&id=4948d6a2&scoped=true"
import script from "./waiting-approval.vue?vue&type=script&lang=ts"
export * from "./waiting-approval.vue?vue&type=script&lang=ts"
import style0 from "./waiting-approval.vue?vue&type=style&index=0&id=4948d6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4948d6a2",
  null
  
)

export default component.exports